import { render, staticRenderFns } from "./UserAccessModel.vue?vue&type=template&id=0d849320"
import script from "./UserAccessModel.vue?vue&type=script&lang=js"
export * from "./UserAccessModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports